<template>
  <div :class="$style.container">
    <div :class="$style.content">
      <Title :class="$style.contentTitle" :title-params="slice.primary.partnership_title" />
      <RichText :text-params="slice.primary.partnership_description" :class="$style.contentDescription" />
      <PLink :class="$style.link" :simple-url="slice.primary.partnership_link.url" is-highlight color="bluko">
        {{ slice.primary.partnership_link_text }}
      </PLink>
    </div>
    <div :class="$style.cards">
      <div v-for="(item, index) in slice.items" :key="`card-${index}`" :class="$style.card">
        <PImage :class="$style.cardImage" :image-object="item.partnership_reason_illu" />
        <Title :class="$style.cardTitle" is-large-title :title-params="item.partnership_reason_title" />
        <RichText :text-params="item.partnership_reason_text" :class="$style.cardDescription" />
      </div>
    </div>
  </div>
</template>

<script>
import RichText from '~/components/RichText'
import Title from '~/components/Title'
import PImage from '~/components/PImage'
import PLink from '~/components/PLink'

export default {
  name: 'Partnership',
  components: {
    RichText,
    Title,
    PImage,
    PLink,
  },
  props: {
    slice: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style lang="scss" module>
.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 24px;

  @include above(medium) {
    flex-direction: row;
    gap: 80px;
    max-width: 1280px;
    margin: 80px auto 128px;
  }
}

.content {
  @include above(medium) {
    padding-right: 0;
    padding-left: 80px;
  }
}

.contentTitle {
  font-weight: 200;
  font-size: 32px;
  line-height: 48px;
}

.contentDescription {
  margin: 10px 0 24px;

  color: $gray-700;
  @include above(small) {
    margin: 16px 0 40px;
  }
}

.cards {
  display: grid;
  gap: 24px;
  margin-top: 40px;

  @include above(small) {
    grid-template-rows: auto auto;
    grid-template-columns: 300px 300px;
    gap: 40px;
  }

  @include above(medium) {
    margin: 0 24px 0 0;
  }
}

.card {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px;
  border-radius: 8px;

  text-align: center;

  background-color: #fff4ee;
}

.cardImage {
  width: 48px;
}

.cardTitle h3 {
  margin-bottom: 4px;
}

.cardTitle {
  margin-top: 16px;

  @include typo-body-bold;
}

.cardDescription p {
  color: $gray-700;
  line-height: 24px;
}
</style>
